import type { Theme } from "@mui/material";
import { Stack } from "@mui/material";
import type { SystemStyleObject } from "@mui/system";
import type { ReactNode, Ref } from "react";

interface Props {
  ref?: Ref<HTMLDivElement>;
  component?: React.ElementType;
  sx?: SystemStyleObject<Theme>;
  children: ReactNode;
}

const PropertyItemContainer = ({ ref, component, sx, children }: Props) => {
  return (
    <Stack
      component={component || "div"}
      ref={ref}
      sx={(theme) => ({
        bgcolor: theme.palette.background.paper,
        borderRadius: "4px",
        border: `1px solid ${theme.palette.divider}`,
        width: "100%",
        ...sx,
      })}
    >
      {children}
    </Stack>
  );
};

export default PropertyItemContainer;
